<!-- @format -->
<work-modal>
  <style>
    .modal .no-image {
      height: 172px;
    }
  </style>
  <div class="modal js-modal" is="modal-base" is-open="{ props.isOpen }">
    <div class="modal__bg" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <div
          class="contents-inner_block"
          if="{ props.work.limited_publish_level==0 || props.work.is_authed==1}"
        >
          <div class="box_flex01 margin-spacing-3_bottom">
            <h3 class="modal_heading">{ props.work.title }</h3>
          </div>
          <div class="container_profile">
            <div class="box_pic">
              <div class="picture">
                <div if="{ !props.work.thumbnail }" class="no-image">
                  制作実績
                </div>
                <img
                  if="{ props.work.thumbnail }"
                  src="/public-info/works/api/v1/image?file_hash={ props.work.thumbnail.hash }"
                  alt=""
                />
              </div>
            </div>
            <div class="box_text">
              <h3 class="heading-04 margin-spacing-1_bottom">担当分野</h3>
              <ul class="scope_list margin-spacing-2_bottom">
                <li
                  class="scope_list-item"
                  each="{ fields in props.work.in_charge_fields}"
                >
                  <span class="skill_label">{ fields }</span>
                </li>
              </ul>

              <h3 class="heading-04 margin-spacing-1_bottom">コメント</h3>
              <p class="comment">{ props.work.comment }</p>

              <ul class="reference_list margin-spacing-2_top">
                <li class="reference_list-item" if="{ props.work.url }">
                  <a
                    class="reference_list-item_website"
                    target="_blank"
                    href="{ props.work.url }"
                  >
                    サイトを開く
                  </a>
                </li>
                <li class="reference_list-item" if="{ props.work.files }">
                  <a
                    class="reference_list-item_documents"
                    target="_blank"
                    href="/public-info/works/api/v1/image?file_hash={ props.work.files.hash }"
                    download
                  >
                    参考資料を見る
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!--/.container_profile-->
        </div>
        <!--/.contents-inner_block-->
        <div
          class="contents-inner_block"
          if="{ props.work.limited_publish_level==1 && !props.work.is_authed }"
        >
          <div class="box_flex01 margin-spacing-3_bottom">
            <h3 class="modal_heading">
              { props.info.name
              }さんの非公開実績を見るためのリクエストを送信します
            </h3>
          </div>
          <h4></h4>
          <ul class="scope-detail_list">
            <li class="scope-detail_list-item">
              下記の情報を入力して「リクエストを送る」のボタンを押してください。
              <ul class="scope-detail_sublist">
                <li class="scope-detail_sublist-item">
                  「名前」と「メールアドレス」は、非公開実績を見るためのリクエストをするために使用します。
                </li>
                <li class="scope-detail_sublist-item">
                  リクエストが承認されたら、入力されたメールアドレスにパスワード等の限定ファイルを閲覧するための諸情報が届きます。
                </li>
                <li class="scope-detail_sublist-item">
                  パスワードは発行されてから72時間有効です。利用がない場合は無効となりますのでご注意ください。
                </li>
              </ul>
            </li>
          </ul>
          <table class="detail_table">
            <tbody>
              <tr class="detail_table-row">
                <th class="detail_table-heading">名前</th>
                <td class="detail_table-data">
                  <div class="box_flex02">
                    <div class="box_w70">
                      <input class="text_input" type="text" name="name" />
                      <div if="{ state.errors.name }" class="error">
                        { state.errors.name }
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="detail_table-row">
                <th class="detail_table-heading">メールアドレス</th>
                <td class="detail_table-data">
                  <div class="box_flex02">
                    <div class="box_w70">
                      <input class="text_input" type="text" name="mail" />
                      <div if="{ state.errors.mail }" class="error">
                        { state.errors.mail }
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="detail_table-row">
                <th class="detail_table-heading">コメント</th>
                <td class="detail_table-data">
                  <div class="box_flex02">
                    <div class="box_w70">
                      <textarea
                        class="textarea_input"
                        name="comment"
                      ></textarea>
                      <div if="{ state.errors.comment }" class="error">
                        { state.errors.comment }
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="box_flex03">
            <button
              class="button button-secondary-large"
              onclick="{ onRequest }"
            >
              リクエストを送る
            </button>
          </div>
        </div>
        <!--/.contents-inner_block-->
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->
  <script>
    import di from "dependeny-injection";
    import base from "../modal-base.riot";
    import PublicInfoApi from "@model/skillsheet/public-info-api.js";

    export default {
      components: {
        "modal-base": base,
      },
      state: {
        errors: {},
      },
      onBeforeMount() {
        this.PublicInfoApi = new PublicInfoApi();
      },
      onRequest(e) {
        di.toast.push("プレビューからはリクエストできません。", "negative");
      },
    };
  </script>
</work-modal>
